import request from "@/utils/request";

export default function swapOrderResource(id,isUp) {
    return request({
        url: `/storeProductResource/agency/swap/`+id+`/`+isUp,
        method: 'get',
    })
}
